import React from 'react';
import { Box, SxProps } from '@mui/material';

import config from '@occc/config';

import { MAP_HEIGHT, MAP_WIDTH, DEFAULT_URL, MAP_ZOOM, MAP_TITLE } from './constants';

interface IMapProps {
  longitude?: number;
  latitude?: number;
  width?: string | number;
  height?: string | number;
  sx?: SxProps;
  withBorder?: boolean;
  title?: string;
  zoom?: number;
}

export const Map: React.FC<IMapProps> = ({
  longitude,
  latitude,
  width,
  height,
  sx,
  withBorder,
  title,
  zoom,
}) => {
  if (!longitude && !latitude) {
    return null;
  }

  const params: Record<string, string> = {
    key: config.google.mapsApiKey || '',
    center: `${latitude},${longitude}`,
    q: `${latitude},${longitude}`,
    zoom: String(zoom || MAP_ZOOM),
  };

  const queryString = new URLSearchParams(params).toString();

  return (
    <Box
      component='iframe'
      title={title || MAP_TITLE}
      width={width || MAP_WIDTH}
      height={height || MAP_HEIGHT}
      frameBorder='0'
      allowFullScreen
      src={`${DEFAULT_URL}${queryString}`}
      sx={{
        ...(withBorder && { border: '1px solid', borderColor: 'divider' }),
        ...sx,
      }}
    />
  );
};
